import { NextRouter } from 'next/router';

import { ENV } from '../constants/environments';
import { PRODUCT_FILTER_KEYS } from '../constants/ui';

const {
  SORT_BY: SORT_BY_KEY,
  ASSET_TYPE: ASSET_TYPE_KEY,
  TEXT_SEARCH_V2: TEXT_SEARCH_KEY_V2,
  TEXT_SEARCH_V1: TEXT_SEARCH_KEY_V1,
} = PRODUCT_FILTER_KEYS;

export const allProductsLink = (libraryId: number) => (libraryId === 3 ? '/3d' : '/products');
export const categoryBaseUrl = (libraryId: number) => (libraryId === 3 ? '/3d' : '/collections');
export const getSubcategoryPath = (category: any, subcategory: any) => {
  return `${categoryBaseUrl(category.library_id)}/${category.slug}--${subcategory.slug}/category`;
};
export const mapQueryParams = (router: NextRouter): { [key: string]: string | string[] } => {
  const searchKey = ENV.useV2ProductEndpoints ? TEXT_SEARCH_KEY_V2 : TEXT_SEARCH_KEY_V1;
  const searchValue = router.query[searchKey];
  const sortByValue = router.query[SORT_BY_KEY];
  const assetTypeValue = router.query[ASSET_TYPE_KEY];
  const query = {};
  if (searchValue) query[searchKey] = searchValue;
  if (sortByValue) query[SORT_BY_KEY] = sortByValue;
  if (assetTypeValue) query[ASSET_TYPE_KEY] = assetTypeValue;
  return query;
};
